// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modify-solidity-contract-dialog[data-v-2b59d852] .el-dialog{width:var(--common-dialog-large-width)}.modify-solidity-contract-dialog .alert-info[data-v-2b59d852]{margin-bottom:var(--base-size-20);width:90%;margin-left:5%}.modify-solidity-contract-dialog .el-form[data-v-2b59d852]{margin-right:var(--base-size-48)}", ""]);
// Exports
module.exports = exports;
